import { ReactComponent as RechtUndTechnikHausanschluss } from "../assets/svg/RechtUndTechnik/RUndTHausanschluss.svg";
import { ReactComponent as RechtUndTechnikErzeugungsanlagen } from "../assets/svg/RechtUndTechnik/RUndTErzeugungsanlagen.svg";
import { PrimaryButton } from "../assets/primaryButton/primaryButton";
import "./components.scss";
import Card from "../assets/card/card";
import { Popup } from "../assets/popup/popup";
import "./popupPosition.scss";


export function RechtUndTechnikCards(props: {text: any}) {
  return <>
      <Card
        topicSVG={<RechtUndTechnikHausanschluss />}
        headline={props.text.RechtUndTechnik.RechtUndTechnikHausanschluss.headline}
        text={props.text.RechtUndTechnik.RechtUndTechnikHausanschluss.text}
        buttonFunction={() => {window.open(props.text.RechtUndTechnik.RechtUndTechnikHausanschluss.link,'_self')}}
        item="item-1"
        data-testid="item"
      />
      <Card
        topicSVG={<RechtUndTechnikErzeugungsanlagen />}
        headline={props.text.RechtUndTechnik.RechtUndTechnikErzeugungsanlagen.headline}
        text={props.text.RechtUndTechnik.RechtUndTechnikErzeugungsanlagen.text}
        buttonFunction={() => {window.open(props.text.RechtUndTechnik.RechtUndTechnikErzeugungsanlagen.link,'_self')}}
        item="item-2"
        data-testid="item"
      />
  </>
}



export function RechtUndTechnikPopupContainer (props: {setPopupState: Function}) {
  return <>
    <Popup
      popupClass="formularePopupPosition"
      headline="Formulare & mehr"
      text=""
      buttonText="Mehr erfahren"
      buttonFunction={() => {}}
      buttonClose={() => {
        props.setPopupState();
      }}
      contentPopup = {true}
    >
      <div className="positionButtons">
        <PrimaryButton
          text="Recht & Technik"
          function={() => {window.open(`${process.env.REACT_APP_LINK_HAUSANSCHLUSS_RECHTUNDTECHNIK}`,'_self')}}
          negative={false}
        ></PrimaryButton>
        <PrimaryButton
          text="Produkte & Preise"
          function={() => {window.open(`${process.env.REACT_APP_LINK_HAUSANSCHLUSS_PRODUKTEUNDPREISE}`,'_self')}}
          negative={false}
        ></PrimaryButton>
        <PrimaryButton
          text="Formulare"
          function={() => {window.open(`${process.env.REACT_APP_LINK_HAUSANSCHLUSS_FORMULARE}`,'_self')}}
          negative={false}
        ></PrimaryButton>
      </div>
    </Popup>
  </>
}